import { useInstance } from '../../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { RoundIconButton } from '../../components/button/RoundIconButton.tsx';
import { RemoveIcon } from '../../components/icons/Icons.tsx';
import { MapViewModel } from '../model/MapViewModel.ts';

export const ZoomOutButton: React.FC = () => {

    const mapVM = useInstance(MapViewModel);
    useSubscription(() => mapVM);

    const zoomIn = () => {
        // if we're already at min zoom, setZoom will do nothing
        mapVM.setZoom(mapVM.getZoom() - 1);
    };

    return (
        <RoundIconButton Icon={RemoveIcon} onClick={zoomIn} />
    );
};
